import React from 'react';
import AzureLogo from 'components/Icons/sources/Azure';
import CSVLogo from 'components/Icons/sources/CSV';
import GoogleWorkspaceLogo from 'components/Icons/sources/GoogleWorkspaceLogo';

import * as Types from 'pages/Directory/typings';
import DemoDataLogo from 'components/Icons/sources/DemoDataLogo';

const sourceData = {
  csv: {
    type: 'csv' as Types.SourceType,
    title: 'Upload a CSV',
    description:
      'Quickly and easily upload a CSV file from any external data source like an HR system, or create one using our CSV template. Optionally set up an SFTP integration to automate the process.',
    displayName: 'the CSV file',
    uploadCopy: (
      <>
        Either by using our CSV template below, or by using a direct export from your organization’s
        system of record (HRIS, HCM, Active Directory, etc), upload a file including your people
        data that you’d like to import to Sift. The first row in the file should be a header row
        naming each attribute, and each subsequent row should represent a single person.
      </>
    ),
    logo: <CSVLogo data-testid="csv-logo" />,
  },
  'azure-active-directory': {
    type: 'azure-active-directory' as Types.SourceType,
    title: 'Microsoft Azure Active Directory',
    description: `Sift connects to Azure Active Directory via Microsoft Graph to keep data consistently up to date with that in your Microsoft ecosystem. Administrator access to Azure AD is required.`,
    displayName: 'Azure',
    header: 'Authorize Sift to Access Azure AD',
    subtitle: `You will be taken to a Microsoft website to authorize Sift to connect to Azure Active Directory. You will need an account that has access to read all Users and Groups in your organization.`,
    logo: <AzureLogo />,
  },
  'google-directory': {
    type: 'google-directory' as Types.SourceType,
    title: 'Google Workspace',
    description: `Sift connects to Google Workspace to keep data consistently up to date with that in your Google ecosystem. Administrator access to Google Workspace is required.`,
    displayName: 'Google',
    header: 'Authorize Sift to Access Google Workspace',
    subtitle: `You will be taken to a Google website to authorize Sift to connect. You will need an account that has access to read all Users in your organization.`,
    logo: <GoogleWorkspaceLogo />,
  },
  'demo-data': {
    type: 'demo-data' as Types.SourceType,
    title: 'Use Demo Data',
    description: `Explore Sift features risk-free with Demo Data. Import your own data when you're ready to dive deeper.`,
    displayName: '',
    header: '',
    subtitle: '',
    logo: <DemoDataLogo />,
  },
};

export default sourceData;
